import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=179feddd&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=179feddd&prod&lang=less&scoped=true"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=179feddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179feddd",
  null
  
)

export default component.exports